// extracted by mini-css-extract-plugin
export default {"root":"Pw87rOLiiNHt4ZVtAG3e","img":"La7JpL12GFpR7BlOBF4o","title":"bSau9wL6hRUHOvrHzasu"};